import React from 'react';
import PropTypes from 'prop-types';

import { Col, Row, Form } from 'react-bootstrap-5';
import ManagedInput from 'components/form/managed_input';

import { getLocation } from 'helpers/location_helper';

const LocationForm = ({ location, stateOptions, onLocationChange }) => {
  const { city, state, zip } = location;

  const handleEditLocationField = (value, key) => {
    onLocationChange({
      ...location,
      [key]: value
    });
  };

  const handleZipChange = (zip) => {
    onLocationChange({
      ...location,
      zip: zip.replace(/\D/g, '')
    });

    if (zip.length === 5) {
      getLocation(zip).then((locationData) => {
        const { city, state } = locationData;
        if (city && state) {
          onLocationChange({
            city,
            state,
            zip
          });
        }
      });
    }
  };

  return (
    <div className="form-vertical-field-container">
      <Row>
        <Col md={6} xs={12}>
          <Form.Group className="form-group">
            <Form.Label>City</Form.Label>
            <ManagedInput
              className="form-control"
              name="city"
              placeholder="City"
              value={city}
              onValueChange={value => handleEditLocationField(value, 'city')}
            />
          </Form.Group>

          <Form.Group className="form-group">
            <Form.Label>State</Form.Label>
            <Form.Control
              as="select"
              className="form-select"
              name="state"
              placeholder="select"
              value={state}
              onChange={e => handleEditLocationField(e.target.value, 'state')}
            >
              <option value="">--</option>
              {stateOptions.map(({ value, label }) => <option key={value} value={value || ''}>{label}</option>)}
            </Form.Control>
          </Form.Group>

          <Form.Group className="form-group">
            <Form.Label>Zip</Form.Label>
            <ManagedInput
              className="form-control"
              name="zip"
              placeholder="Zip"
              value={zip}
              onValueChange={newZip => handleZipChange(newZip)}
            />
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
};

LocationForm.propTypes = {
  location: PropTypes.object.isRequired,
  stateOptions: PropTypes.array.isRequired,
  onLocationChange: PropTypes.func.isRequired
};

export default LocationForm;
